import React, { useEffect, useRef } from 'react';
import * as d3 from 'd3';
import PropTypes from 'prop-types';
import { getTextWidth } from '../../core/doc_util';

const CategoricalLegend = ({ width, height, categories }) => {
  const ref = useRef(null);

  const color = d3
    .scaleOrdinal()
    .domain(Object.keys(categories))
    .range(Object.values(categories));

  useEffect(() => {
    const group = d3.select(ref.current);

    let dataL = 0;
    const labelOffset = 40;

    const yOffset = height - 5;

    const legend = group
      .selectAll('.legends4')
      .data(Object.keys(categories))
      .enter()
      .append('g')
      .attr('class', 'legends4')
      .attr('transform', (d, i) => {
        const textWidth = getTextWidth(d, { fontSize: '12px' });
        if (i === 0) {
          dataL = textWidth + labelOffset;
          return 'translate(0,0)';
        }
        const newdataL = dataL;
        dataL += textWidth + labelOffset;
        return `translate(${newdataL},0)`;
      });

    legend
      .append('circle')
      .attr('cx', 10)
      .attr('cy', yOffset - 5)
      .attr('r', 5)
      .style('fill', (d, i) => {
        return color(i);
      });

    legend
      .append('text')
      .attr('x', 20)
      .attr('y', yOffset)
      .text(d => {
        return d;
      })
      .attr('class', 'textselected')
      .style('text-anchor', 'start')
      .style('font-size', 12);
  }, [width, height, categories]);

  return (
    <div>
      <svg width={width} height={height} ref={ref} />
    </div>
  );
};

CategoricalLegend.propTypes = {
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  categories: PropTypes.objectOf(PropTypes.string).isRequired,
};

export default CategoricalLegend;
